'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('./tslib.es6-cd939937.js');

var _configBase = /** @class */ (function () {
    function _configBase() {
        this._confData = {};
    }
    Object.defineProperty(_configBase.prototype, "data", {
        get: function () {
            return this._confData;
        },
        enumerable: false,
        configurable: true
    });
    _configBase.prototype.get = function (key) {
        if (key === void 0) { key = null; }
        if (!key) {
            return null;
        }
        var chunks = key.split('.');
        if (chunks.length > 1) {
            var lastVal = this._confData;
            while (chunks.length) {
                lastVal = this.getRecursive(lastVal, chunks.shift());
            }
            return lastVal;
        }
        else {
            return this._confData[key];
        }
    };
    _configBase.prototype.getRecursive = function (value, name) {
        return value && (value[name] !== null && value[name] !== undefined)
            ? value[name]
            : null;
    };
    // set(key: {}, value:any): boolean
    /**
     * !!!!! important think, if need to clear the object property - need to call set('property.path', null);
     * */
    _configBase.prototype.set = function (key, value) {
        if (value === void 0) { value = null; }
        if (key) {
            var chunks = key.split('.');
            var confData = this._confData;
            var lastKey = key;
            if (chunks.length > 1) {
                while (chunks.length) {
                    lastKey = chunks.shift();
                    confData = this.setRecursive(confData, lastKey, chunks.length === 0);
                }
            }
            if (value && !Array.isArray(value) && typeof value === 'object' && Object.keys(value).length) {
                confData[lastKey] = confData[lastKey] || {};
                for (var subKey in value) {
                    confData[lastKey][subKey] = value[subKey];
                }
            }
            else {
                confData[lastKey] = value;
            }
            return true;
        }
        else {
            console.warn('Config.set, not correct params: ', key, value);
            return false;
        }
    };
    _configBase.prototype.setRecursive = function (data, name, isLast) {
        if (isLast) {
            //      data[name] = value;
            return data;
        }
        else if (!data[name]) {
            data[name] = {};
        }
        return data[name];
    };
    return _configBase;
}());

var ConfigService = /** @class */ (function (_super) {
    tslib_es6.__extends(ConfigService, _super);
    function ConfigService() {
        return _super.call(this) || this;
    }
    ConfigService.prototype.set = function (key, value) {
        if (value === void 0) { value = null; }
        if (typeof key === 'object') {
            for (var subKey in key) {
                // @ts-ignore
                _super.prototype.set.call(this, subKey, key[subKey]);
            }
            return true;
        }
        else {
            return _super.prototype.set.call(this, key, value);
        }
    };
    return ConfigService;
}(_configBase));

exports.ConfigService = ConfigService;
